// @flow

import React from "react";
import { localize } from "redux-i18n";
import { addMinutes } from "date-fns";
import Ajv from "ajv";

import { removeNullAndUndefinedProps } from "@transformers/object";
import actionCreators from "@modules/service/actionCreator";
import { SchemaForm, Button, type StepProps, View } from "@components";

import uiSchema from "./ui-schema";

type OwnProps = $Exact<{
  editing: boolean,
  schema: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step1Rule extends React.Component<Props> {
  validate: *;

  constructor(props: Props) {
    super(props);

    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.validate = new Ajv().compile(this.schema);
  }

  get data() {
    return this.props.data || {};
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      ...uiSchema,
      activeTo: {
        ...uiSchema.activeTo,
        "ui:options": {
          ...uiSchema.activeTo["ui:options"],
          minDate: this.data.activeFrom ? addMinutes(new Date(this.data.activeFrom), 1) : undefined,
        },
      },
    };
  }

  isValid = (data?: Object) => {
    return !this.validate || this.validate(data);
  };

  handleFormRef = (ref: *) => {
    this.formRef = ref;
  };

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = () => {
    if (this.props.handleSubmit && this.isValid(this.data)) {
      this.props.handleSubmit(this.data, true);
    }
  };

  handleChange = (formData: Object) => {
    const data = removeNullAndUndefinedProps(formData);
    this.props.onChange(data, this.isValid(data));
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="gs-container">
          {this.data ? (
            <SchemaForm
              ref={this.formRef}
              className="w-100"
              formData={this.data}
              schema={this.schema}
              uiSchema={this.uiSchema}
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          ) : null}
        </div>
        {!this.props.editing ? (
          <div className="w-100 d-flex justify-content-end mt-5 mb-3">
            <Button
              materialIcon="fast_forward"
              disabled={!this.isValid(this.data)}
              onClick={this.submitForm}
            >
              {this.props.t("NEXT")}
            </Button>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default localize()(Step1Rule);
